var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.app.layout == 'new-app-layout')?[_c('v-row',{on:{"click":function($event){_vm.disableEA = false}}},[_c('auditList',{attrs:{"disabled":_vm.disableEA}})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }